import React from 'react'
import t from 'prop-types'

const ThreeUp = ({ children }) => {
  return (
    <div className="md:grid md:grid-cols-3 gap-10">
      {children.map((child, index) => (
        <div key={index} className="mb-16 md:mb-0 last:mb-0">
          {child}
        </div>
      ))}
    </div>
  )
}

ThreeUp.propTypes = {
  children: t.node.isRequired,
}

ThreeUp.defaultProps = {}

export default ThreeUp
